<template>
  <button class="wishlist-button" :class="{ selected: wishlistselected }" @click="toggleWishlist">
    <span v-if="wishlistselected">
      <img :src="wishlistImg" class="wishlistImg" :alt="wishlistAlt" />
    </span>
    <span v-else>
      <img :src="unwishlistImg" class="wishlistImg" :alt="unwishlistAlt" />
    </span>
  </button>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
const WISHLIST_UPDATED = 'wishlist-updated';
export default {
  name: 'FavouriteProduct',
  props: {
    wishlistImg: { type: String, required: true },
    unwishlistImg: { type: String, required: true },
    wishlistAlt: {
      type: String,
      default: '',
    },
    unwishlistAlt: {
      type: String,
      default: '',
    },
    sku: { type: String, default: null },
    item: {
      type: Object,
      default: () => ({}),
    },
    pdpTagging: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      wishlistItems: [],
      wishlistselected: false,
      productSku: null,
    };
  },
  computed: {
    isInWishlist() {
      return this.wishlistItems.includes(this.productSku);
    },
  },
  mounted() {
    this.resolveSku();
    this.loadWishlist();
    eventBus.on(WISHLIST_UPDATED, this.loadWishlist);
    window.addEventListener('storage', this.onStorageChange);
  },

  beforeUnmount() {
    eventBus.off(WISHLIST_UPDATED, this.loadWishlist);
    window.removeEventListener('storage', this.onStorageChange);
  },
  methods: {
    onStorageChange(event) {
      if (event.key === 'likedProducts') {
        this.loadWishlist();
      }
    },
    resolveSku() {
      if (this.sku) {
        this.productSku = this.sku;
        return;
      }
      const ldJson = document
        .querySelector('script[type="application/ld+json"]')
        ?.innerText.replace(/[\s]+/g, ' ')
        .replace(/\n|\r|\t/g, ' ');
      const data = ldJson ? JSON.parse(ldJson) : null;
      this.productSku = data?.sku || null;
    },
    loadWishlist() {
      const storedProducts = localStorage.getItem('likedProducts');
      this.wishlistItems = storedProducts ? JSON.parse(storedProducts) : [];
      this.updateFlags();
    },
    triggerGtm(actionType) {
      if (this.item?.tag?.common?.product) {
        this.pushFromPlp(actionType);
      } else {
        this.pushFromPdp(actionType);
      }
    },
    pushFromPlp(actionType) {
      const productObj = this.item?.tag?.common?.product || {};

      const obj = {
        event: 'uaevent',
        ecommerce: 'undefined',
        eventCategory: 'Wishlist',
        eventAction: 'Product Wishlist',
        eventLabel: `${productObj.name}::${productObj.id}`,
        product_info: `${productObj.name}::${productObj.id}`,
        event_name: actionType,
      };

      window.dataLayer?.push(obj);
    },

    pushFromPdp(actionType) {
      const productName = document.querySelector('[data-tag-productName]')?.innerText?.trim() || '';
      const obj = {
        event: 'uaevent',
        ecommerce: 'undefined',
        eventCategory: 'Wishlist',
        eventAction: 'Product Wishlist',
        eventLabel: `${productName}::${this.productSku}`,
        product_info: `${productName}::${this.productSku}`,
        event_name: actionType,
      };
      window.dataLayer?.push(obj);
    },

    toggleWishlist() {
      if (!this.productSku) return;

      if (this.isInWishlist) {
        this.removeFromWishlist();
        this.triggerGtm('remove_from_wishlist');
      } else {
        this.addToWishlist();
        this.triggerGtm('add_to_wishlist');
      }
    },
    addToWishlist() {
      if (!this.productSku || this.isInWishlist) return;
      this.wishlistItems.push(this.productSku);
      this.updateStorage();
    },
    removeFromWishlist() {
      this.wishlistItems = this.wishlistItems.filter((sku) => sku !== this.productSku);
      this.updateStorage();
    },
    updateStorage() {
      localStorage.setItem('likedProducts', JSON.stringify(this.wishlistItems));
      eventBus.emit(WISHLIST_UPDATED);
      this.updateFlags();
    },
    updateFlags() {
      this.wishlistselected = this.isInWishlist;
    },
  },
};
</script>
<style scoped>
.wishlistImg {
  width: 30px;
}
</style>
